import { render, staticRenderFns } from "./5num.vue?vue&type=template&id=72003c48"
import script from "./5num.vue?vue&type=script&lang=js"
export * from "./5num.vue?vue&type=script&lang=js"
import style0 from "./5num.vue?vue&type=style&index=0&id=72003c48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports